import React from 'react'

const AuthUserContext = React.createContext({
  user: null,
  modifyUser: () => {}
})

export default AuthUserContext
